import type { ITeacher } from '@/types/teacher'

export default function TeachersListItem({ teacher }: { teacher: ITeacher }) {
  return (
    <a href={`/professores/${teacher.slug}`}>
      <div className="relative not-prose">
        <div className="relative rounded-lg w-full h-72 overflow-hidden">
          <img
            loading="lazy"
            src={
              teacher.image ||
              `https://ui-avatars.com/api/?name=${teacher?.name}&=rounded=true&background=C4C4C4&color=1A1A1A`
            }
            alt={teacher.name}
            className="object-cover w-full h-full rounded-lg"
            width={280}
            height={288}
          />
          <div className="absolute flex p-4 justify-start items-end h-72 top-0 left-0 right-0">
            <div
              aria-hidden="true"
              className="absolute opacity-80 bg-gradient-to-t from-black h-36 bottom-0 left-0 right-0"
            />
            <div className="relative font-semibold text-white flex flex-col">
              <p className="text-xl">{teacher.name}</p>
              {teacher.stuff && (
                <p className=" text-sm">{teacher.stuff[0]?.name}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}
